/**
 * Returns the active SKU for the product model matching the given path.
 *
 * @param {Array} productModels - Normalized product models array from pricing data
 * @param {string} productPath - DAM path of the product content fragment
 * @returns {string|null} The active SKU, or null if no match is found
 */
export function getSkuByProductPath(productModels, productPath) {
  if (!productModels || !productPath) return null;
  return (
    productModels.flatMap((m) => (Array.isArray(m) ? m : [m])).find((m) => m.productPath === productPath)?.activeSku
    ?? null
  );
}

/****
 * Checks if any product in the product models is purchasable, or if a specific selected product is purchasable.
 *
 * @param {Array} productModels - Normalized product models array from pricing data
 * @param {string|null} selectedProduct - SKU of the selected product (optional)
 * @returns {boolean} True if the selected product (if provided) or any product is purchasable, otherwise false
 */
export function isProductPurchasable(productModels, selectedProduct = null) {
  if (!productModels) return false;

  const allProducts = productModels.flatMap((m) => (Array.isArray(m) ? m : [m])).flatMap((m) => m.products);

  if (selectedProduct) {
    const selected = allProducts.find((p) => p.sku === selectedProduct);
    return selected?.isPurchasable ?? false;
  }

  return allProducts.some((p) => p.isPurchasable);
}
